import * as React from "react";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsContextValue {
  crumbs: Crumb[];
  setCrumbs: React.Dispatch<React.SetStateAction<Crumb[]>>;
}

const BreadcrumbsContext = React.createContext<BreadcrumbsContextValue>({
  crumbs: [],
  setCrumbs: () => {},
});

export function BreadcrumbsProvider({ children }: React.PropsWithChildren) {
  const [crumbs, setCrumbs] = React.useState<Crumb[]>([]);
  const value = React.useMemo(() => ({ crumbs, setCrumbs }), [crumbs]);
  return (
    <BreadcrumbsContext.Provider value={value}>
      {children}
    </BreadcrumbsContext.Provider>
  );
}

export function useBreadcrumbsContext() {
  return React.useContext(BreadcrumbsContext);
}

export function useBreadcrumbs(crumbs: Crumb[]) {
  const { setCrumbs } = useBreadcrumbsContext();
  const serialized = JSON.stringify(crumbs);
  React.useEffect(() => {
    setCrumbs(JSON.parse(serialized));
    return () => setCrumbs([]);
  }, [serialized, setCrumbs]);
}
